<template>
  <div>
    <breadcrumbPage></breadcrumbPage>
    <div class="content EC_width">
      <div class="menuWrap marginBottom20">
        <div class="t1rt1 display_between">
          <!-- <img src="../../assets/img/icon/sanjiao3.png"
               alt=""> -->
          <img src="../../assets/img/icon/sanjiao4.png"
               @click="toTopNian(1)"
               alt="">
          <span>{{topNian}}年</span>
          <img src="../../assets/img/icon/sanjiao1.png"
               v-show="topNian>=topNianA"
               alt="">
          <img src="../../assets/img/icon/sanjiao2.png"
               v-show="topNian<topNianA"
               @click="toTopNian(2)"
               alt="">
        </div>
        <div class="t1rt2">
          <table>
            <tr>
              <td v-for="(item) in 12"
                  :key="item"
                  :class="topYue==item?'t1rt2Yue td':'td'"
                  @click="toTopYue(item)"
                  :style="item==12?'margin-right:0':''">{{item}}月</td>
            </tr>
          </table>
        </div>
      </div>
      <div class="display_flex">
        <div class="leftContent">
          <div class="content_title display_between">
            <div class="content_leftText">{{ content_leftText }}</div>
          </div>
          <div v-if="pageCount > 0">
            <div class="listWrapBar"
                 v-for="(item, index) in meetingList"
                 :key="'0' + index">
              <div class="imgList marginRight20"
                   @click="toMeeting(item.id)">
                <img :src="item.mtg_Image_ResUrl" />
              </div>
              <a href="javascript:;"
                 class="listItem">
                <div class="listItemTitle"
                     @click="toMeeting(item.id)">
                  {{ item.mtg_Name }}
                </div>
              </a>
            </div>
          </div>
          <div v-else
               style="text-align:center;"><strong>暂无数据</strong></div>
          <div class="pagination_Wrap"
               v-if="pageCount > 0">
            <pagination :total="pageCount"
                        :limit="pageSize"
                        :page="pageIndex"
                        @page-change="pageChange"></pagination>
          </div>
        </div>

        <div class="rightVideoList">
          <div class="rightVedioTitle display_between marginBottom20">
            <div class="leftTitle">相关课程推荐</div>
          </div>
          <div class="videoWrap marginBottom30"
               v-for="(item, index) in courseList"
               :key="'0' + index"
               @click="courseclick(item)">
            <img class="imgtran"
                 :src="item.acr_PictResUrl"
                 alt=""
                 width="300"
                 height="169" />
            <div class="videoTitle">
              {{ ellipsis(item.title, 18) }}
            </div>
          </div>
          <div class="rightVedioTitle display_between">
            <div class="leftTitle">内容聚类</div>
          </div>
          <div class="display_flex linkRight marginBottom20">
            <ul class="ulList_block">
              <li v-for="(item, index) in NewClusteringList"
                  :key="'0' + index"
                  @click="onsearch(item.labelName)">
                <a href="javascript:;">{{ ellipsis(item.labelName, 6) }}({{ item.count }})</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import format from '@/assets/unit/unit.js';
import breadcrumbPage from '../home/breadcrumbPage';
import Pagination from '../components/page/pagination.vue';
export default {
  name: 'meetingList',
  data () {
    return {
      pageIndex: 1,
      content_leftText: '',
      pageSize: 8,
      pageCount: 0,
      NewClusteringList: [], //咨询内容聚类
      strID: '',
      labelName: '',
      courseList: [], //推荐课程
      columnPid: 0,
      columnid: 0,
      matched: [],
      topYue: 1,
      meetingList: [],
      topNian: 2021,
      topNianA: 2021
    };
  },
  components: {
    breadcrumbPage,
    Pagination
  },
  created () {
    var myDate = new Date();
    this.topNian = myDate.getFullYear();
    this.topNianA = myDate.getFullYear();
    var tMonth = myDate.getMonth();
    this.topYue = tMonth + 1
    this.matched = this.$route.matched;
    this.content_leftText = this.$route.query.title;
    this.columnPid = this.$route.query.pid;
    this.columnid = this.$route.query.cid;
    this.matched.forEach(element => {
      if (element.name == this.$route.name) element.meta.breadcrumbTitle = this.content_leftText;
    });
    this.GetNewClustering(Number(this.$route.query.pid), 0);
    this.GetMeetingList()
  },
  methods: {
    /**点击分页事件 */
    pageChange (page) {
      if (document.body.scrollTop) document.body.scrollTop = 0;
      else document.documentElement.scrollTop = 0;
      if (page == this.pageIndex) return;
      this.pageIndex = page;
    },
    formatTime (datatime, timeformat) {
      return format(datatime, timeformat);
    },
    /**获取内容聚类数据 */
    GetNewClustering (columnPid, columnid) {
      let _this = this;
      _this.httphelper
        .post('/api/NewApi/GetNewInfoList', {
          parentID: columnPid,
          childrenID: columnid
        })
        .then(res => {
          if (res.data.code == 200) {
            let newInfoViewsList = res.data.data.gpSiteNewInfoViewsViews;
            if (newInfoViewsList != null && newInfoViewsList.length > 0) {
              _this.strID = '';
              _this.NewClusteringList = [];
              newInfoViewsList.forEach(element => {
                if (!_this.strID.includes(element.id)) {
                  _this.strID += element.id + ',';
                }
              });
              _this.strID = _this.strID.substring(0, this.strID.length - 1);
              _this.httphelper
                .post('/api/NewApi/GetNewClustering', {
                  ids: _this.strID
                })
                .then(res => {
                  if (res.data.code == 200) {
                    _this.NewClusteringList = res.data.data;
                  }
                });
              _this.GetCourseRecommendPageList();
            }
          }
        });
    },
    /**相关课程推荐 */
    GetCourseRecommendPageList () {
      let _this = this;
      _this.labelName = '';
      _this.courseList = [];
      _this.NewClusteringList.forEach(element => {
        this.labelName += element.labelName + ',';
      });
      this.labelName = this.labelName.substring(0, this.labelName.length - 1);
      _this.httphelper
        .post('/api/ArticleApi/GetCourseRecommendPageList', {
          year: '',
          period: '',
          id: 0,
          keywords: _this.labelName,
          recommendNumber: 4
        })
        .then(res => {
          if (res.data.code == 200) {
            _this.courseList = res.data.data;
          }
        });
    },
    GetMeetingList () {
      this.httphelper
        .post('/api/MeetingApi/GetMeetingPageList', {
          metName: '',
          sortType: 1,
          mtgType: Number(this.columnid),
          year: Number(this.topNian),
          month: Number(this.topYue),
          page: this.pageIndex,
          limit: this.pageSize
        })
        .then(res => {
          if (res.data.code == 200) {
            this.meetingList = res.data.data;
            this.pageCount = res.data.data.length
          }
        });
    },

    /**课程跳转 */
    courseclick (item) {
      let id = item.courseInfoId == 0 ? item.id : item.courseInfoId;
      let url = this.httphelper.IsDebugCgphome() +'/detail?courseId=' + id;
      window.open(url);
    },
    onsearch (keywords) {
      const { href } = this.$router.resolve({
        path: '/home/searchPage?',
        query: {
          labelname: keywords
        }
      });
      window.open(href, '_blank');
    },
    toTopYue (index) {
      this.topYue = index
      this.GetMeetingList()
    },
    toTopNian (index) {
      if (index == 1) this.topNian--
      else if (index == 2) this.topNian++
      this.GetMeetingList()
    },
    clickSpecial (item) {
    },
    toMeeting (id) {
      const { href } = this.$router.resolve({
        name: 'meetingpc',
        query: {
          mid: id
        }
      });
      window.open(href, '_blank');
    }
  }
};
</script>

<style scoped>
.content {
    padding-top: 40px;
    flex: 1;
}

.menuWrap table {
    border-collapse: collapse;
    width: 100%;
}

.menuWrap table td {
    border: 1px solid #dee2e6;
    height: 38px;
    text-align: center;
    cursor: pointer;
    width: 172px;
}
.menuWrap table td a {
    display: inline-block;
    width: 100%;
    height: 100%;
    line-height: 38px;
}
.activeTd a {
    background-color: #0b8686;
    color: #fff;
}
.leftContent {
    flex: 1;
}
.content_title {
    height: 60px;
    line-height: 60px;
    border-bottom: 1px solid #ddd;
    margin-bottom: 20px;
}
.content_leftText {
    font-size: 20px;
    font-weight: bold;
    color: #0b8686;
    border-bottom: 1px solid #0b8686;
}
.content_title a {
    color: #999;
}
/* 列表 */
.listWrapBar {
    display: flex;
    border-bottom: 1px solid #ddd;
    padding: 20px 0;
}
.imgList {
    width: 150px;
}
.imgList img {
    width: 100%;
    cursor: pointer;
}
.listItem {
    flex: 1;
}

.listItem:last-child {
    border-bottom: none;
}

.listItemTitle {
    font-size: 18px;
    margin-bottom: 10px;
    position: relative;
}
.listItemSub {
    font-size: 16px;
    color: #ccc;
}

.opera {
    margin-top: 20px;
}

.gree_block,
.red_block,
.blue_block {
    display: inline-block;
    padding: 4px 8px;
    font-size: 12px;
    margin-right: 5px;
}

.gree_block {
    border: 1px solid #469a97;
    color: #469a97;
}

.red_block {
    border: 1px solid #cc6d6e;
    color: #cc6d6e;
}

.blue_block {
    border: 1px solid #417393;
    color: #417393;
}

.inforshow {
    color: #ccc;
}
/* 右侧样式设置 */
.rightVideoList {
    width: 310px;
    margin-left: 50px;
}
/* 右面视频列表样式 */

.rightVedioTitle {
    height: 56px;
    line-height: 56px;
    border-bottom: 1px solid #ddd;
}
.leftTitle {
    font-size: 20px;
    font-weight: bold;
    border-bottom: 1px solid #333;
}
.videoWrap video {
    width: 100%;
}
.videoTitle {
    font-size: 16px;
    margin-top: 12px;
}
.linkRight li {
    margin-bottom: 20px;
}
.t1rt1 {
    width: 1240px;
    height: 34px;
    background: #0b8586;
    padding: 0 10px;
    box-sizing: border-box;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 16px;
    margin-bottom: 10px;
}
.t1rt1 img {
    padding: 2px;
    cursor: pointer;
}
.t1rt2 {
    width: 1240px;
    margin-bottom: 30px;
}
.t1rt2 table {
    border-collapse: collapse;
    border-spacing: 0;
}
.t1rt2 tr {
    width: 1240px;
    height: 34px;
    display: flex;
    justify-content: space-between;
}
.t1rt2 .td {
    width: 101.5px;
    height: 34px;
    background: #ffffff;
    border: 1px solid #eaeaea;
    box-sizing: border-box;
    margin: 0 2px 2px 0;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    line-height: 30px;
    text-align: center;
    cursor: pointer;
}
.t1rt2 td:hover {
    background: #e8f6f5;
}
.t1rt2 .t1rt2Yue {
    color: #fff;
    background-color: #0b8485;
    border-color: #0b8485;
}
.t1rt2 .t1rt2Yue:hover {
    color: #fff;
    background-color: #0b8485;
    border-color: #0b8485;
}
</style>
